exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-head-info{margin-bottom:30px}.list-head-info .city{font-size:13px;font-weight:700;line-height:14px}.list-head-info .qty{font-size:12px;color:gray}.search-block-view{width:100%;background:#fff}.search-block-view .text-center{text-align:center}.search-block-view .property-item{opacity:1}.search-block-view .property-item .col-1{background:#f3f3f3;width:350px;max-width:100%;min-height:180px}.search-block-view .property-item .property-body{padding:0 15px;line-height:22px}", ""]);

// exports
